<script setup lang="ts">
import { computed } from "vue";

const RADIUS = 4;
const CENTER_X = 10;
const CENTER_Y = 10;

const props = withDefaults(
  defineProps<{
    progress?: number;
  }>(),
  {
    progress: 0.5,
  }
);

const arcPath = computed(() => {
  const clampedFill = Math.min(1, Math.max(0, props.progress));
  if (clampedFill === 0) {
    return "";
  }
  if (clampedFill === 1) {
    return `M ${CENTER_X} ${CENTER_Y - RADIUS} A ${RADIUS} ${RADIUS} 0 1 1 ${CENTER_X - 0.001} ${CENTER_Y - RADIUS} Z`;
  }

  const angle = clampedFill * 2 * Math.PI - Math.PI / 2;
  const x = CENTER_X + RADIUS * Math.cos(angle);
  const y = CENTER_Y + RADIUS * Math.sin(angle);
  const largeArcFlag = clampedFill > 0.5 ? 1 : 0;
  return `M ${CENTER_X} ${CENTER_Y} L ${CENTER_X} ${CENTER_Y - RADIUS} A ${RADIUS} ${RADIUS} 0 ${largeArcFlag} 1 ${x} ${y} Z`;
});
</script>

<template>
  <svg viewBox="-0.5 -0.5 21 21" fill="currentColor" stroke="currentColor" aria-hidden="true">
    <rect x="3" y="3" width="14" height="14" rx="7" stroke-width="3" fill="none" />
    <path v-if="progress > 0" stroke="none" :d="arcPath" />
  </svg>
</template>
